import { toast } from "react-toastify";

export const toastSuccess = (message: string): void => {
  toast.success(message, {
    hideProgressBar: false,
    delay: 0,
    autoClose: 2000,
    toastId: "success",
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const toastError = (message: string, err?: any): void => {
  const data = err?.response?.data;
  if (data?.status === 400) {
    const reason = `${data?.reason}`;
    if (reason && reason != "undefined") {
      message += `\n${reason}`;
    }

    const errors = mapErrorsToString(data?.errors);
    if (errors) {
      message += `\n${errors}`;
    }
  }

  toast.error(message, { hideProgressBar: true, delay: 0, autoClose: 0 });
};

export const toastWarning = (message: string): void => {
  toast.warning(message, { hideProgressBar: true, delay: 0, autoClose: 0 });
};

export const mapErrorsToString = (errors?: Record<string, string[]>): string => {
  return mapErrorsToArray(errors).join("\n");
};

export const mapErrorsToArray = (errors?: Record<string, string[]>): string[] => {
  const safeErrors = errors || [];
  const results: string[] = [];
  Object.entries<string[]>(safeErrors).map(([, keyErrors]) => {
    keyErrors.forEach((e) => results.push(e));
    return null;
  });
  return results;
};
